import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import UserForm from '../components/user-form';
import './page.css';

const UserPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} un utilisateur`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/utilisateurs"
            theme="danger"
          />
        </div>

        <UserForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default UserPage;
